import { api } from "api";
// trainingStatusTypes : pending, registered, tobeCompleted, targeted

export const changeSelectedTrainingType = (selectedType) => {
  return {
    type: "CHANGE_SELECTED_TRAINING_TYPE",
    payload: selectedType,
  };
};

export const getTrainings = (
  trainingStatusType,
  onBegin,
  onSuccess,
  onError
) => {
  let apiEndPoint = "";
  let actionType = "GET_TRAININGS";
  switch (trainingStatusType) {
    case "pendingApproval":
      apiEndPoint = "/api/training/get-trainings-pending-approval";
      break;
    case "registered":
      apiEndPoint = "/api/training/get-registered-trainings";
      break;
    case "toBeCompleted":
      apiEndPoint = "/api/training/get-trainings-to-be-completed";
      break;
    case "targeted":
      apiEndPoint = "/api/training/get-targeted-trainings";
      break;
    case "completed":
      apiEndPoint = "/api/training/get-completed-trainings";
      break;
    case "potential":
      apiEndPoint = "/api/training/get-potential-trainings";
      break;
    case "role":
      apiEndPoint = "/api/training/get-role-trainings";
      break;
      
    default:
      return null;
  }
  return async (dispatch) => {
    onBegin();
    await api
      .get(apiEndPoint)
      .then((res) => {
        dispatch({
          type: `${actionType}_SUCCESS`,
          selectedTrainingType: trainingStatusType,
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: `${actionType}_ERROR`,
          selectedTrainingType: trainingStatusType,
          payload: e,
        });
        onError(e);
      });
  };
};

export const getTrainingDetail = (trainingId, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/training/get-training-detail/${trainingId}`)
      .then((res) => {
        dispatch({
          type: "GET_TRAINING_DETAIL_SUCCESS",
          payload: res.data,
        });
        onSuccess(res.data.data.trainingDetail);
      })
      .catch((e) => {
        dispatch({
          type: "GET_TRAINING_DETAIL_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getTrainingParticipationRules = (
  trainingId,
  isPackage,
  timePlanId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(
        `/api/training/get-participation-rules/${trainingId}/${isPackage}/${timePlanId}`
      )
      .then((res) => {
        dispatch({
          type: "GET_TRAINING_PARTICIPATION_RULES_SUCCESS",
          payload: res.data,
        });
        onSuccess(res.data.data);
      })
      .catch((e) => {
        dispatch({
          type: "GET_TRAINING_PARTICIPATION_RULES_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getTrainingDocuments = (
  trainingId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/training/get-training-documents/${trainingId}`)
      .then((res) => {
        dispatch({
          type: "GET_TRAINING_DOCUMENTS_SUCCESS",
          payload: res.data,
        });
        onSuccess(res.data.data.documents);
      })
      .catch((e) => {
        dispatch({
          type: "GET_TRAINING_DOCUMENTS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const createRegistrationInformationalVideos = (
  timePlanId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/create-registration-informational-video", {
        timePlanId: timePlanId,
      })
      .then((res) => {
        dispatch({
          type: "REGISTER_INFORMATIONAL_VIDEO_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "REGISTER_INFORMATIONAL_VIDEO_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const createTrainingRequest = (
  isPackage,
  trainingId,
  timePlanId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/create-training-request", {
        isPackage,
        trainingId,
        timePlanId,
      })
      .then((res) => {
        dispatch({
          type: "REQUEST_TRAINING_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "REQUEST_TRAINING_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const createEmployeeRegistrationTraining = (
  employeeId,
  timePlanId,
  isPackage,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/create-employee-registration-training", {
        employeeId,
        timePlanId,
        isPackage,
      })
      .then((res) => {
        dispatch({
          type: "CREATE_EMPLOYEE_REGISTRATION_TRAINING_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "CREATE_EMPLOYEE_REGISTRATION_TRAINING_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const cancelEmployeeRegistrationTraining = (
  employeeId,
  timePlanId,
  isPackage,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/cancel-employee-registration-training", {
        employeeId,
        timePlanId,
        isPackage,
      })
      .then((res) => {
        dispatch({
          type: "CANCEL_EMPLOYEE_REGISTRATION_TRAINING_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "CANCEL_EMPLOYEE_REGISTRATION_TRAINING_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const rejectTrainingRequest = (
  trainingRequestId,
  rejectionReason,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/reject-training-request", {
        trainingRequestId,
        rejectionReason,
      })
      .then((res) => {
        dispatch({
          type: "REJECT_TRAINING_REQUEST_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "REJECT_TRAINING_REQUEST_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const approveTrainingRequest = (
  trainingRequestId,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/approve-training-request", {
        trainingRequestId,
      })
      .then((res) => {
        dispatch({
          type: "APPROVE_TRAINING_REQUEST_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "APPROVE_TRAINING_REQUEST_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const doPlanTrainingRequest = (
  employeeId,
  trainingId,
  quarter,
  year,
  isPackage,
  onBegin,
  onSuccess,
  onError
) => {
  return async (dispatch) => {
    onBegin();
    await api
      .post("/api/training/do-plan-training-request", {
        employeeId,
        trainingId,
        quarter,
        year,
        isPackage,
      })
      .then((res) => {
        dispatch({
          type: "DO_PLAN_TRAINING_REQUEST_SUCCESS",
          payload: res,
        });
        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: "DO_PLAN_TRAINING_REQUEST_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getCertificate = (certificateNo, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    const fname = `${certificateNo}.jpg`;
    onBegin();
    await api
      .get(`/api/certification/get/${certificateNo}`)
      .then((res) => {
        onSuccess(res, fname);
      })
      .catch((e) => {
        dispatch({
          type: "DOWNLOAD_CERTIFICATE_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const potentialTraningsExport = (keyword, onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/training/export-potential-trainings/${keyword}`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_POTENTIAL_TRAININGS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getAllRegisteredTrainings = (onBegin, onSuccess,onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/training/get-all-registered-trainings`)
      .then((res) => {
        dispatch({
          type: `ALL_REGISTERED_TRAININGS_SUCCESS`,
          payload: res.data,
        });

        onSuccess();
      })
      .catch((e) => {
        dispatch({
          type: `ALL_REGISTERED_TRAININGS_ERROR`,
          payload: e,
        });
        onError(e);
      });
  };
};

export const allRegisteredTrainingsExport = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get(`/api/training/export-all-registered-trainings`)
      .then((res) => {
        const fileName = res.headers["content-disposition"].split(';')[1].split('=')[1];
        onSuccess(res, fileName);
      })
      .catch((e) => {
        dispatch({
          type: "EXPORT_ALL_REGISTERED_TRAININGS_ERROR",
          payload: e,
        });
        onError(e);
      });
  };
};

export const getTrainingRequests = (onBegin, onSuccess, onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/training/get-training-requests")
      .then((res) => {
        onSuccess(res.data.data);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

export const getInformationalVideos = (onBegin, onSuccess,onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/training/get-informational-videos")
      .then((res) => {
        dispatch({
          type: `INFORMATIONAL_VIDEOS_SUCCESS`,
          payload: res.data,
        });

        onSuccess(res);
      })
      .catch((e) => {
        dispatch({
          type: `INFORMATIONAL_VIDEOS_ERROR`,
          payload: e,
        });
        onError(e);
      });
  };
};

export const getVideoCategories = (onBegin, onSuccess,onError) => {
  return async (dispatch) => {
    onBegin();
    await api
      .get("/api/training/get-video-categories")
      .then((res) => {
        onSuccess(res);
      })
      .catch((e) => {
        onError(e);
      });
  };
};

// export const getTrainingDocument = (documentNo, onBegin, onSuccess, onError) => {
//   return async (dispatch) => {
//     const fname = `${certificateNo}.jpg`;
//     onBegin();
//     await api
//       .get(`/api/certification/get/${certificateNo}`)
//       .then((res) => {
//         onSuccess(res, fname);
//       })
//       .catch((e) => {
//         dispatch({
//           type: "DOWNLOAD_CERTIFICATE_ERROR",
//           payload: e,
//         });
//         onError(e);
//       });
//   };
// };
